export function buildTableSuccessActionBasedOnCount(results, type, rowsKey) {
    if (results.count) {
        return {
            count: results.count,
            pages: Math.ceil(results.count / results.limit),
            [rowsKey]: results.rows,
            type
        };
    } else {
        let pages = (results.offset / results.limit) + 1;
        if (results.hasMore) {
            pages++;
        }

        return {
            hasMore: results.hasMore,
            pages: pages,
            [rowsKey]: results.rows,
            type
        };
    }
}
